module.exports = __webpack_public_path__ + "static/media/gallery.5d3ba6b9.jpg";